<template>
  <v-flex xs12 sm12>
    <v-card
      class="mx-auto"    >
      <v-card
        flat
      >
        <!-- <v-img
          src="https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png"
          aspect-ratio="2.75"
        ></v-img> -->
          <v-layout
            column
            fill-height
          >
            <!-- <v-card-title>
            <router-link to="/">
              <v-btn dark icon>
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </router-link>

              <v-spacer></v-spacer>

              <v-btn dark icon class="mr-3">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </v-card-title>

            <v-spacer></v-spacer> -->

            <v-card-title class="pl-5 pt-5">
              <div class="display-1 pl-5 pt-5">{{ item.name }} </div>
            </v-card-title>
          </v-layout>

        <v-list two-line>
          <v-list-tile
          >
            <v-list-tile-action>
              <a :href="'tel:' + item.mobile">
                <v-icon color="indigo">phone</v-icon>
              </a>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title><a :href="'tel:' + item.mobile">{{ item.mobile }}</a></v-list-tile-title>
              <v-list-tile-sub-title>Celular</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <a :href="'sms:' + item.mobile">
                <v-icon>chat</v-icon>
              </a>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="">
            <v-list-tile-action></v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.dateOfBirth }}</v-list-tile-title>
              <v-list-tile-sub-title>Data Nasc.</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <!-- <v-icon>chat</v-icon> -->
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.email }}</v-list-tile-title>
              <v-list-tile-sub-title>E-mail</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <a :href="'mailto:' + item.email">
                <v-icon>mail</v-icon>
              </a>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="">
            <v-list-tile-action></v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.covenant }}</v-list-tile-title>
              <v-list-tile-sub-title>Convênio</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">location_on</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.addrees }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.city }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-card>
  </v-flex>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('patient', ['getPatient']),
      ...mapGetters('app', ['getTheme', 'getDevice'])
    },
    data: () => ({
      profile: true,
      miniVariant: true,
      clipped: true,
      drawer: false,
      fixed: false,
      isLoading: false,
      cards: [
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
        { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
      ],
      item: {},
      model: null,
      search: null,
      active: null,
      text: 'Lorem ipsum dolor sit amet.'
    }),
    mounted () {
      this.$bus.$on('getMedicalRecord', this.loadingRecord)
    },
    methods: {
      loadingRecord (selected) {
        if (selected === 'profile') {
          this.item = this.getPatient
        }
      },
      next () {
        const active = parseInt(this.active)
        this.active = (active < 2 ? active + 1 : 0)
      },
      show (type) {
        if (type === 0) {
          this.profile = false
        } else if (type === 1) {
          this.profile = true
          this.item = this.getPatient
        } else if (type === 2) {
          this.profile = false
        } else if (type === 3) {
          this.profile = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/patient/profile/index.vue